import BossModel from "@/models/BossModel";

export default class PassportSelection extends BossModel {

    static apiUrl = 'agent/passport-selection';

    static entity = 'agentPassportSelections';

    static fields() {
        return {
            id: this.number(null).nullable(),
            agent_id: this.number(null).nullable(),
            data_cid: this.number(null).nullable(),
            created_at: this.attr(null),
        }
    }

    static dataCid = [
        {id: 1, label: 'Passport document nummer'},
        {id: 2, label: 'Passport verloop datum'},
        {id: 3, label: 'Nationaliteit'},
    ];

    Agent() {
        return this.getRelated('agent');
    }

    static isSelected(agentId,dataCid) {
        return PassportSelection.query().where('data_cid', dataCid).where('agent_id',agentId).first();
    }
}
